<template lang="pug">
  v-container#pricing.justify-center( tag="section")
    v-row.text-center(align="center" justify="center")
      v-col.mb-10(cols="12")
        pages-heading.mb-12
          | Selecciona el plan que gustes
        .display-1.font-weight-light.grey--text.text--lighten-2
          | You have Free Unlimited Updates and Premium Support on
          br.hidden-sm-and-down
          | each package.
      template(v-for="(plan, i) in plans")
        v-col.d-flex(:key="i" cols="12" sm="6" md="3")
          pages-plan-card(:plan="plan")
        v-col.pa-6(v-if="(i === 1 && $vuetify.breakpoint.smAndDown) && i + 1 !== plans.length" :key="`divider-${i}`" cols="12")
          v-divider
</template>

<script>
  export default {
    name: 'PagesPricing',

    components: {
      PagesHeading: () => import('@/views/pages/components/Heading'),
      PagesPlanCard: () => import('@/views/pages/components/PlanCard'),
    },

    data: () => ({
      plans: [
        {
          id_plan: 'BEGINNERS',
          heading: 'Beginners',
          icon: 'mdi-sofa',
          title: '20.000$',
          text: 'This is good if your company size is between 2 and 10 Persons.',
          itemList: [
            { text: 'Facturas Ilimitadas' },
            { text: 'Gestión de Inventarios' },
            { text: 'Registro de Proveedores' },
            { text: 'Facturas de Compra Ilimitadas' },
            { text: '1 Punto de Venta' },
            { text: 'Sin Usuarios Adicionales' },
            { text: 'Información de tus Ventas en Tiempo Real' },
            { text: 'Capacitación y Soporte' },
            { text: 'Personalizalo con tu Logo y Marca' },
            { text: 'Importación Automatica de Inventario' },
            { text: 'Sin Costos de Actualización' },
          ],
        },
        {
          id_plan: 'STARTUP',
          best: true,
          heading: 'startup',
          icon: 'mdi-home',
          title: '40.000$',
          text: 'This is good if your company size is between 2 and 10 Persons.',
          itemList: [
            { text: 'Facturas Ilimitadas' },
            { text: 'Gestión de Inventarios' },
            { text: 'Registro de Proveedores' },
            { text: 'Facturas de Compra Ilimitadas' },
            { text: 'Dos Puntos de Venta' },
            { text: '2 Usuarios Adicionales' },
            { text: 'Información de tus Ventas en Tiempo Real' },
            { text: 'Capacitación y Soporte' },
            { text: 'Personalizalo con tu Logo y Marca' },
            { text: 'Importación Automatica de Inventario' },
            { text: 'Sin Costos de Actualización' },
          ],
        },
        {
          id_plan: 'BASIC',
          heading: 'Basic',
          icon: 'mdi-domain',
          title: '80.000$',
          text: 'This is good if your company size is between 11 and 99 Persons.',
          itemList: [
            { text: 'Facturas Ilimitadas' },
            { text: 'Gestión de Inventarios' },
            { text: 'Registro de Proveedores' },
            { text: 'Facturas de Compra Ilimitadas' },
            { text: 'Cuatro Puntos de Ventas' },
            { text: '4 Usuarios Adicionales' },
            { text: 'Información de tus Ventas en Tiempo Real' },
            { text: 'Capacitación y Soporte' },
            { text: 'Personalizalo con tu Logo y Marca' },
            { text: 'Importación Automatica de Inventario' },
            { text: 'Sin Costos de Actualización' },
          ],
        },
        {
          id_plan: 'PRO',
          heading: 'Pro',
          icon: 'mdi-bank',
          title: '120.000$',
          text: 'This is good if your company size is 99+ or greater Persons.',
          itemList: [
            { text: 'Facturas Ilimitadas' },
            { text: 'Gestión de Inventarios' },
            { text: 'Registro de Proveedores' },
            { text: 'Facturas de Compra Ilimitadas' },
            { text: 'Puntos de Ventas Ilimitados' },
            { text: '10 Usuarios Adicionales' },
            { text: 'Información de tus Ventas en Tiempo Real' },
            { text: 'Capacitación y Soporte' },
            { text: 'Personalizalo con tu Logo y Marca' },
            { text: 'Importación Automatica de Inventario' },
            { text: 'Sin Costos de Actualización' },
          ],
        },
      ],
    }),
  }
</script>
